"use client";

import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const treatments = [{
  id: 1,
  title: "Loja Física & Microvix",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592892/img/implantes_bw_gold.png",
  benefit1: "Gestão completa de PDV e estoque",
  benefit2: "Controle financeiro de alta precisão",
  benefit3: "Relatórios estratégicos em tempo real",
  link: "/MicrovixPage"
}, {
  id: 2,
  title: "Atacado & e-Millennium",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592892/img/clareamento_bw_gold.png",
  benefit1: "Logística avançada com WMS",
  benefit2: "Faturamento em larga escala",
  benefit3: "Ecossistema Omnichannel integrado",
  link: "/EMillenniumPage"
}, {
  id: 3,
  title: "Varejo & Seta Digital",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592892/img/ortodontia_bw_gold.png",
  benefit1: "Especializado em calçados e moda",
  benefit2: "Agilidade no atendimento ao cliente",
  benefit3: "Gestão de compras e grade de produtos",
  link: "/DigitalArrowPage"
}, {
  id: 4,
  title: "Marketplace & PluggTo",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592892/img/facetas_bw_gold.png",
  benefit1: "Conexão com os maiores players",
  benefit2: "Sincronização de estoque e preços",
  benefit3: "Centralização de pedidos e fretes",
  link: "/HomePage"
}, {
  id: 5,
  title: "Consultoria Linx",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592892/img/prevencao_bw_gold.png",
  benefit1: "Implantação guiada por especialistas",
  benefit2: "Suporte técnico humanizado e ágil",
  benefit3: "Treinamentos focados em resultados",
  link: "/AboutUsPage"
}];
export default function MenuDeTratamentos() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="101996" id="especialidades-por-segmento" className="bg-background/70 backdrop-blur-xl text-foreground py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerReveal.ref} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-1000 ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="font-sans font-bold text-4xl md:text-5xl text-foreground mb-6">
            Especialidades por Segmento
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-sans">
            Soluções inteligentes de ERP e gestão para transformar a eficiência operacional do seu negócio no varejo, atacado e indústria.
          </p>
          <div className="w-24 h-1 bg-[#FF006E] mx-auto mt-8 rounded-full opacity-80"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {treatments.map((item, i) => <TreatmentCard key={item.id} item={item} index={i} />)}
        </div>
      </div>
    </section>;
}
function TreatmentCard({
  item,
  index
}: {
  item: (typeof treatments)[0];
  index: number;
}) {
  const cardReveal = useRevealOnScroll({
    threshold: 0.2
  });
  const delay = index % 3 * 150;
  return <div data-index={index} ref={cardReveal.ref} className={`transition-all duration-1000 ease-out ${cardReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16"}`} style={{
    transitionDelay: `${delay}ms`
  }}>
      <Card className="h-full flex flex-col bg-card/50 backdrop-blur-md border-border hover:border-primary transition-all duration-500 group overflow-hidden shadow-sm hover:shadow-lg">
        <div className="relative aspect-[4/3] overflow-hidden">
          <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110 grayscale" />
          {}
          <div className="absolute inset-0 bg-primary/10 mix-blend-color transition-opacity duration-500 group-hover:opacity-40"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/10 to-transparent"></div>
        </div>

        <CardHeader className="relative -mt-12 pb-2 z-10">
          <CardTitle className="font-sans font-bold text-2xl text-foreground drop-shadow-sm">
            {item.title}
          </CardTitle>
        </CardHeader>

        <CardContent className="flex-grow pt-4 z-10">
          <ul className="space-y-3">
            {[item.benefit1, item.benefit2, item.benefit3].map((benefit, idx) => <li key={idx} data-index={idx} className="flex items-start gap-3">
                  <span className="mt-1 flex-shrink-0 w-5 h-5 rounded-full bg-[#FF006E]/10 flex items-center justify-center">
                    <Check className="w-3.5 h-3.5 text-[#FF006E]" />
                  </span>
                  <span className="text-foreground font-sans text-sm leading-relaxed">
                    {benefit}
                  </span>
                </li>)}
          </ul>
        </CardContent>

        <CardFooter className="pt-6 pb-8 z-10">
          <Button asChild variant="outline" className="w-full group/btn border-[#FF006E]/30 hover:border-[#FF006E] hover:bg-[#FF006E] hover:text-white text-[#FF006E] font-semibold transition-all duration-300">
            <Link to={item.link}>
              Saiba Mais
              <ArrowRight className="w-4 h-4 ml-2 transition-transform duration-300 group-hover/btn:translate-x-1" />
            </Link>
          </Button>
        </CardFooter>
      </Card>
    </div>;
}